<template>
  <div class="date_date">
    <mu-paper :z-depth="1" class="demo-date-picker">
      <mu-date-picker
        :date.sync="date3"
        :min-date="minDate"
        :no-display="true"
        :should-disable-date="allowedDates"
        @change="onDateChange"
      >
        <div
          slot="day"
          slot-scope="prop"
          :class="{
            choose_bg: chooseBgColor(prop.date)
          }"
          @click="chooseDate(prop)"
        >
          <!-- 按照周几选择 -->
          <span
            :class="{
              choose_color: chooseColor(prop.date)
            }"
            class="date_pos"
            >{{ prop.date.getDate() }}</span
          >
          <!-- 点击选中背景色 -->
          <!-- <span :class="{ choose_color: false }" class="date_pos">{{
            prop.date.getDate()
          }}</span> -->
          <!-- 多周期显示选中期数 -->
          <!-- <span
            :class="{
              choose_color:
                (prop.date.getDate() - chooseCurDate.getDate()) % (n + 1) ===
                  0 && prop.date.getDate() >= chooseCurDate.getDate()
            }"
            class="date_pos"
            >{{ prop.date.getDate() }}</span
          > -->
        </div>
      </mu-date-picker>
    </mu-paper>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      // totalPeriods,
      // periodInterval: this.preCheckout.periodInterval
      date3: undefined,
      minDate: new Date(this.$route.query.deliveryPlanTime.replace(/-/g, "/")),
      chooseCurDate: new Date(
        this.$route.query.defaultPlanTime.replace(/-/g, "/")
      ),
      defaultDate: new Date(
        this.$route.query.deliveryPlanTime.replace(/-/g, "/")
      ),
      choosedWeekday: 2,
      n: this.$route.query.periodInterval, //鲜奶卡间隔
      num: this.$route.query.totalPeriods, //鲜奶卡期数
      propsDate: this.$route.query.deliveryPlanTime.slice(0, 10), //后端的初始默认值
      dateStart: new Date(new Date().getTime()),
      dateEnd: new Date(new Date().getTime())
    };
  },
  // mounted() {
  //   console.log(this.$route.query.deliveryPlanTime);
  //   console.log(this.$route.query.deliveryPlanTime.slice(0, 10));
  // },
  watch: {
    chooseCurDate(res) {
      console.log("---", res);
    }
  },
  methods: {
    onDateChange(date) {
      // console.log("====", date);
      const format = "YYYY-MM-DD";
      const diffDays = dayjs(dayjs(date).format(format)).diff(
        dayjs(this.minDate).format(format),
        "days"
      );
      if (diffDays < 0) {
        this.chooseCurDate = this.minDate;
      }
    },
    chooseBgColor(date) {
      const format = "YYYY-MM-DD";
      return (
        dayjs(date).format(format) === dayjs(this.chooseCurDate).format(format)
      );
    },
    chooseColor(date1) {
      const format = "YYYY-MM-DD";
      const diffDays = dayjs(dayjs(date1).format(format)).diff(
        dayjs(this.chooseCurDate).format(format),
        "days"
      );
      const initDiffDays = dayjs(dayjs(date1).format(format)).diff(
        dayjs(this.minDate).format(format),
        "days"
      );
      return (
        initDiffDays >= 0 &&
        diffDays >= 0 &&
        diffDays <= (this.num - 1) * (this.n + 1) &&
        Math.abs(diffDays) % (this.n + 1) === 0
      );
    },
    // 有多少周期需要添加颜色
    dateBg() {
      for (var i in this.num) {
        if (i > 0) {
          console.log(i);
        }
      }
      // console.log(this.bgs);
    },
    // 允许选择的范围
    allowedDates(date) {
      this.dateStart = new Date().getTime().valueOf();
      this.dateEnd = new Date(
        new Date().getTime() + 30 * 24 * 60 * 60 * 1000
      ).valueOf();
      let dateCur = date.getTime().valueOf();
      return this.dateStart < dateCur && dateCur > this.dateEnd;
    },
    // 点击选择日期
    chooseDate(props) {
      // console.log(props);
      if (props.disabled) {
        return;
      }
      // console.log(props.date.getDate());
      this.chooseCurDate = props.date;
      // console.log(
      //   dayjs(this.chooseCurDate.getTime()).format("YYYY-MM-DD"),
      //   "this.chooseCurDate"
      // );
      // console.log(
      //   dayjs(this.chooseCurDate).format("YYYY-MM-DD"),
      //   "this.chooseCurDate"
      // );
      this.choosedWeekday = props.date.getDay();
      this.$emit("chooseDate", dayjs(this.chooseCurDate).format("YYYY-MM-DD"));
      // console.log(this.choosedWeekday, "chooseCurDate");
    }
  }
};
</script>
<style lang="less" scoped>
.date_date {
  background: #fff;
  ::v-deep .mu-elevation-1 {
    box-shadow: none;
  }
  ::v-deep .mu-datepicker-year-container {
    width: 100%;
  }
  ::v-deep .mu-datepicker-monthday-row {
    margin-top: 15px;
  }
  ::v-deep .demo-date-picker {
    margin: 0;
  }
  ::v-deep .mu-picker {
    width: 100%;
  }
  ::v-deep .mu-datepicker-svg-icon {
    color: rgba(0, 0, 0, 0.5);
  }
  ::v-deep .mu-icon-button {
    width: 24px;
    height: 24px;
    padding: 24px 0;
  }
  ::v-deep .mu-day-button {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
  }
  ::v-deep .mu-day-button.disabled > .mu-day-button-text {
    opacity: 1;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.2) !important;
  }
  ::v-deep .mu-day-button.disabled > .mu-day-button-text {
    opacity: 1;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.2) !important;
  }
  ::v-deep .mu-day-button-text {
    font-size: 16px;
    font-weight: 600;
  }
  ::v-deep .mu-day-button-bg {
    background: #bf9264;
  }
  ::v-deep .mu-month-button-bg {
    background: #bf9264;
  }
  ::v-deep .mu-day-button:hover:not(:disabled) .mu-day-button-bg {
    opacity: 1;
  }
  ::v-deep .mu-datepicker-monthday {
    min-height: 300px;
    height: auto;
  }
  ::v-deep .mu-year-button.selected > .mu-year-button-text {
    color: #bf9264;
  }
  ::v-deep .mu-datepicker-week {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);
    line-height: 24px;
    padding: 12px 8px;
  }
  ::v-deep .mu-datepicker-week span:first-child {
    color: #bf9264;
  }
  ::v-deep .mu-datepicker-week span:last-child {
    color: #bf9264;
  }
  .choose_bg {
    width: 34px;
    height: 34px;
    background: #bf9264;
    border-radius: 17px;
    font-size: 16px;
    font-weight: bold;
    margin: auto;
    line-height: 24px;
    .choose_color {
      color: #fff !important;
    }
  }
  .date_pos {
    margin-top: 5px;
    display: inline-block;
  }
  .choose_color {
    color: #bf9264;
    opacity: 1 !important;
  }
}
</style>
